import { useState } from 'react';
import { authClient } from '../api/auth';
type GenericObject = { [key: string]: any };

export const useApi = (
    apiAction: () => Promise<any>,
    resolveMethod?: (res: GenericObject) => void,
): { response: any; fetchMethod: () => void } => {
    const [response, setResponse] = useState({ data: {}, isLoading: false, error: {}, isSuccess: false });

    const fetchMethod = async () => {
        setResponse({
            data: {},
            isLoading: true,
            error: {},
            isSuccess: false,
        });

        try {
            // Shared token gate: concurrent calls wait for the same refresh operation.
            await authClient.ensureTokenIsValid();
            const res = await apiAction();
            setResponse({ data: res, isLoading: false, error: {}, isSuccess: true });
            resolveMethod && resolveMethod(res);
            return;
        } catch (err: any) {
            console.log('Error occurred...', err);
            setResponse({ data: {}, isLoading: false, error: err as any, isSuccess: false });
        }
    };

    return { response, fetchMethod };
};
